import {Ajax} from '../helpers/ajax';
import {Analytics} from '../helpers/analytics';
import {ElementHelpers} from '../helpers/element-helpers';
import {Modal} from './modal';
import {Scroll} from '../helpers/scroll';
/**
 * Is using icon toggler so it checks the active class of that
 */
export class JobSave {
	constructor(elem) {
		this.jobsList = elem;

		this.saveVacancyButton = this.jobsList.querySelectorAll('[data-save-vacancy]');

		this.removeAllBtn = document.querySelectorAll('[data-vacancies-saved-clear]');

		this.init();
	}

	static get Urls() {
		return {
			ADD: '/restservices/bewaardevacatures/add/',
			REMOVE: '/restservices/bewaardevacatures/remove/',
			REMOVE_ALL: '/restservices/bewaardevacatures/removeAll'
		}
	}

	static get classNames() {
		return {
			SAVED: 'saved',
			ACTIVE: 'button__save-vacancy--active',
			DISABLED: 'disabled',
			COUNTER_PARENT: 'main-menu__sub-menu-list-link--has-saved-vacancies'
		}
	}

	static getSelector() {
		return '#jobboard, #saved-vacancies, #job-content';
	}

	init() {
		this.saveVacancyButton.forEach( (button) => {
			this.initClickEvents(button);
		});
		ElementHelpers.addEventListeners(this.removeAllBtn, 'click', (e) => {
			e.preventDefault();
			this.handleRemoveAll(e);
		})
	}

	initClickEvents(button){
		button.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			const target = event.currentTarget;
			let isSavedVacancyPage = document.getElementById('saved-vacancies');
			if(!target.classList.contains(JobSave.classNames.DISABLED)){ // Using disabled class instead of disabled attribute, else JS click events aren't working anymore
				if (target.classList.contains('saved') || isSavedVacancyPage) {
					JobSave.remove(target, isSavedVacancyPage);
				} else {
					JobSave.save(target);
				}
			}
		})
	}

	static save(element) {
		JobSave.updateAllButtons(element, 'add', JobSave.classNames.DISABLED);
		Ajax.POST(JobSave.Urls.ADD + element.dataset.saveVacancy).then(() => {
			let current = JobSave.getCurrent();
			JobSave.updateCounters(current+1);

			JobSave.updateAllButtons(element, 'add', JobSave.classNames.ACTIVE);
			JobSave.updateAllButtons(element, 'add', JobSave.classNames.SAVED, true);
			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.DISABLED);

			const messageBox = document.querySelector('.messages-fixed');
			const savedMessage = messageBox ? messageBox.querySelector('.job-saved') : '';

			if(savedMessage) JobSave.showMessage(messageBox, savedMessage);

			Analytics.measure({
				label: `save vacancy ${element.dataset.saveVacancy}`,
				category: element.getAttribute(Analytics.analyticsTags.component),
				action: 'click - interact'});
		}, () => {
			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.DISABLED);
		});
	}

	static remove(element, isSavedVacanciesPage) {
		JobSave.updateAllButtons(element, 'add', JobSave.classNames.DISABLED);
		Ajax.POST(JobSave.Urls.REMOVE + element.dataset.saveVacancy).then(() => {
			let current = JobSave.getCurrent();
			JobSave.updateCounters(current-1);

			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.ACTIVE);
			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.SAVED, true);
			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.DISABLED);
			JobSave.updateAllButtons(element, 'remove', 'active');

			const messageBox = document.querySelector('.messages-fixed');
			const removedMessage = messageBox ? messageBox.querySelector('.job-removed') : '';

			if(removedMessage) JobSave.showMessage(messageBox, removedMessage);

			if (isSavedVacanciesPage) {
				const vacancyCard = element.parentElement;
				vacancyCard.classList.add('animate--fade-out');
				setTimeout(() => {
					ElementHelpers.removeElement(vacancyCard);
				}, 300);

				if (JobSave.getCurrent() < 1) {
					JobSave.toggleNoResults();
				}
			}
			Analytics.measure({
				label: `remove vacancy ${element.dataset.saveVacancy}`,
				category: element.getAttribute(Analytics.analyticsTags.component),
				action: 'click - interact'
			});
		}, () => {
			JobSave.updateAllButtons(element, 'remove', JobSave.classNames.DISABLED);
		});
	}

	static updateAllButtons(element, action, className, updateText) {
		const vacancyNumber = element.dataset.saveVacancy;
		const wrapper = document.querySelector(JobSave.getSelector());
		const buttons = wrapper.querySelectorAll(`[data-save-vacancy="${vacancyNumber}"]`);
		const starIcon = '<span class=\'icon icon\'><svg focusable=\'false\'><use xlink:href=\'#star\'></use></svg></span>';

		buttons.forEach((button) => {
			if(action === 'add'){
				button.classList.add(className);
				if(updateText && button.dataset.textRemove) button.innerHTML = button.classList.contains('link__button--full-width-mobile') ? button.dataset.textRemove : starIcon + button.dataset.textRemove;
			}else{
				button.classList.remove(className);
				if(updateText && button.dataset.textSave) button.innerHTML =  button.classList.contains('link__button--full-width-mobile') ? button.dataset.textSave : starIcon + button.dataset.textSave;
			}
		})
	}

	static getCurrent(){
		const counters = document.querySelectorAll('[data-job-count]');
		return parseInt(counters[0].innerHTML);
	}

	static updateCounters(amount) {
		const counters = document.querySelectorAll('[data-job-count]');
		counters.forEach((counter) => {
			counter.innerHTML = amount;
			if(amount >= 1 && counter.parentElement.classList.contains('main-menu__sub-menu-list-link')){
				counter.parentElement.classList.add('main-menu__sub-menu-list-link--has-saved-vacancies');
			}else{
				counter.parentElement.classList.remove('main-menu__sub-menu-list-link--has-saved-vacancies');
			}
		});
	}

	static toggleNoResults(){
		const jobsList = document.getElementById('saved-vacancies');
		const bottomLinks = jobsList.nextElementSibling;
		if(bottomLinks){
			bottomLinks.classList.add('animate--fade-out');
			setTimeout(() => {
				ElementHelpers.removeElement(bottomLinks);
			}, 300);
		}

		const noResultsContainer = document.querySelector('[data-lazy-no-results]');
		if(noResultsContainer) {
			setTimeout(() => {
				noResultsContainer.dataset.lazyNoResults = 'visible';
				noResultsContainer.style.display = 'block';
			}, 300);
		}
	}

	/**
	 * shows a message and hides it later
	 *
	 * @param {Node} message - the message to show
	 * @returns {void}
	 */
	static showMessage(messageBox, message) {

		if(message) {

			const msg = message.cloneNode(true);

			msg.classList.remove('hidden');

			messageBox.appendChild(msg);

			setTimeout(() => {
				msg.classList.add('animate--fade-out');
			}, 2000);

			setTimeout(() => {
				ElementHelpers.removeElement(msg);
			}, 2500)
		}
	}

	handleRemoveAll(e){
		const target = e.currentTarget;
		const modalContent = target.dataset.modalContent ? JSON.parse(target.dataset.modalContent) : '';
		const modal = new Modal(modalContent);

		modal.handleAction(() => {
			this.removeAll();
			const analyticsData = {
				category: target.getAttribute(Analytics.analyticsTags.component),
				action: target.getAttribute(Analytics.analyticsTags.action),
				label: target.getAttribute(Analytics.analyticsTags.label)
			};
			Analytics.measure(analyticsData);
		})

	}

	removeAll(){
		Ajax.POST(JobSave.Urls.REMOVE_ALL).then(() => {
			JobSave.updateCounters(0);
			JobSave.toggleNoResults();
			const jobsList = document.getElementById('saved-vacancies');
			if(jobsList){
				jobsList.classList.add('animate--fade-out');
				setTimeout(() => {
					ElementHelpers.removeElement(jobsList);
				}, 300);
			}
			Scroll.scrollPageTo(0, 500, 0);
		});
	}

}
